import * as React from 'react';
import { Form, Segment } from 'semantic-ui-react';
import './UnitChart.scss';
import { UnitSensorInterface } from 'src/container/UnitSensor/shared';
import { UnitInterface } from './shared';
import UnitSensorChart from 'src/container/UnitSensor/UnitSensorChart';
import { inject, observer } from 'mobx-react';
import { UnitSensorStore } from 'src/stores/application/unitsensor';
import { ChartType, StatComparisionType, StatisticsType } from 'src/services/graphql/Models';
// import { chartTypeOptions } from 'src/container/Chart/shared';
// import { statTypeOptions } from 'src/container/TriggerableStats/TriggerableStatEdit';
// import { statComparisionTypeOption } from '../TriggerableStats/TriggerableStatEdit';
import { DatetimeInput } from 'react-datetime-inputs';
import moment from 'moment';
import { processPotentialArray } from '../../shared/utility';

interface UnitSensorEditProps {
    fromObject: Partial<UnitInterface>;
    unitsensors?: UnitSensorStore;
}

@inject('unitsensors')
@observer
export default class UnitSensorEdit extends React.Component<
    UnitSensorEditProps, 
    any
> {
    handleChange = this._handleChange.bind(this);
    
    constructor(props: UnitSensorEditProps) {
        super(props);
        const { fromObject } = props;
        
        this.state = { 
            ...fromObject,
            chartType: ChartType.line,
            
            fromDate: moment().subtract(1, 'days'),
            toDate: moment(),
            statType: StatisticsType.value,
            comparisionType: StatComparisionType.notCompared,
            comparedToStatType: StatisticsType.value,
            comparisionValue: 0,
        };
    }

    renderChart(unitSensor: UnitSensorInterface) {
        return (
            <div>
                <UnitSensorChart
                    fromObject={unitSensor}
                    forUnit={true}
                    override={this.state}
                />
                
            </div>
        );

    }
    handleOnChange(name: string, datetime: any) {
        this.setState({
            [name]: datetime
        });
    }

    renderChartConfigurations() {
        return (
            <Segment>
                <div className="time-range">
                    <div className="range-input">
                        <div className="label">From Time</div>
                        <div className="input">
                            <DatetimeInput
                                datetime={this.state.fromDate}
                                className="test"
                                onChange={this.handleOnChange.bind(this, 'fromDate')}
                            />
                        </div>
                    </div>
                    
                    <div className="range-input">
                        <div className="label">To Time</div>
                        <div className="input">
                            <DatetimeInput
                                datetime={this.state.toDate}
                                className="test"
                                onChange={this.handleOnChange.bind(this, 'toDate')}
                            />
                        </div>
                    </div>
                </div>

                {/* <Form.Field>
                    <label>Chart Type</label>
                    <Form.Select 
                        required
                        options={chartTypeOptions.slice(1)}
                        placeholder="Chart Type" 
                        name="chartType" 
                        defaultValue={this.state.chartType} 
                        onChange={this.handleChange} 
                    />
                </Form.Field> */}
                
                {this.state.chartType === ChartType.line ? 
                    (
                        <Form.Field>        
                            <br/>
                            <label>Break Line On Error</label>
                            <Form.Checkbox 
                                toggle 
                                name="breakOnError" 
                                defaultChecked={this.state.breakOnError}
                                onChange={this.handleChecked.bind(this)} 
                            />
                        </Form.Field>
                    ) :
                    undefined
                }
                {/* <Form.Field>  
                    <Form.Select
                        label="Statistic Type" 
                        onChange={this.handleChange}
                        options={statTypeOptions}
                        placeholder="What information is to be displayed?" 
                        name="statType" 
                        defaultValue={this.state.statType} 
                    />
                </Form.Field> */}
                    
                {/* <Form.Field>
                    <Form.Select
                        label="Comparision" 
                        onChange={this.handleChange}
                        options={statComparisionTypeOption}
                        placeholder={`Comparing the Stat With (optional)`}
                        name="comparisionType" 
                        defaultValue={this.state.comparisionType} 
                    />
                </Form.Field> */}

                {/* {(this.state.comparisionType !== StatComparisionType.notCompared) ?
                    (       
                        <div>
                            <Form.Field>  
                                <Form.Select
                                    label="Statistic Type" 
                                    onChange={this.handleChange}
                                    options={statTypeOptions}
                                    placeholder={`What value is Compared with?`} 
                                    name="comparedToStatType" 
                                    defaultValue={this.state.comparedToStatType} 
                                />
                            </Form.Field>
                            
                            {(this.state.comparedToStatType === StatisticsType.value) ?
                                (       
                                    <Form.Field>  
                                        <Form.Input
                                            label="Compared with Value:" 
                                            onChange={this.handleChange}
                                            placeholder="value stat is compared with" 
                                            name="comparisionValue" 
                                            defaultValue={this.state.comparisionValue} 
                                        />
                                    </Form.Field>
                                ) : null
                            }
                        </div>
                    )
                    : null
                */}

            </Segment>
        );
    }

    render() {
        const { unitsensors, fromObject } = this.props;
        const unitSensorItems =  unitsensors.getParsedItems;
        let currentUnitSensors: any[] = [];
        processPotentialArray(unitSensorItems, (unitSensors, unitSensorsIndex) => {
            if (Array.isArray(unitSensors)) {
                unitSensors.forEach(
                    (unitSensor, unitSensorIndex) => {
                        if (
                            fromObject.typedId.includes(unitSensor.unitId)
                        ) {
                            currentUnitSensors.push(
                                <div key={`${unitSensorIndex}`}>
                                    {this.renderChart(unitSensor)}
                                </div>
                            );
                        }
                    }
                );
            } else {
                const _us: any = unitSensors;
                if (
                    fromObject.typedId.includes(_us.unitId)
                ) {
                    currentUnitSensors.push(
                        <div key={`${unitSensorsIndex}`}>
                            {this.renderChart(_us)}
                        </div>
                    );
                }
            }
        });
        return(
            <Segment>
                {this.renderChartConfigurations()}
                {currentUnitSensors}               
            </Segment>
        );
    }

    _handleChange(
        e: any, 
        { 
            name, value 
        }: {
            name: string, 
            value: any
        }
    ) {
        this.setState({ [name]: value });
    }

    handleChecked (e: any, {checked, name}: any) {
        this.setState({
            [name] : checked
        });
    }
}


// WEBPACK FOOTER //
// ./src/container/Unit/UnitChart.tsx